import React from 'react';
import ReactToolTip  from 'react-tooltip';
import $ from 'jquery';
import firewallOptions from './../../firewall/firewallOptions';
import { getUnique } from '../../../utility/utility';


class NetworkRules extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enableedit: false,
            enablerules: false,
            firewalltype: '',
            enableditfirewall: '',
            getselectedoption: '',
            type:this.props.type,
            firewallOptions: firewallOptions,
            isFirewallEditShow: false,
            isDuplicateRules: false,
            sources: [
                {
                    ethertype: 'IPv4',
                    value: 'ALLIPv4',
                    remote_ip_prefix: '0.0.0.0/0'
                },
                {
                    ethertype: 'IPv6',
                    value: 'ALLIPv6',
                    remote_ip_prefix: '::/0'
                }
            ],
            rulesListApi: [],
            rulesList: [],
            isAction:false

        };
        
    }

   
    componentDidMount() {
       
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.rulesListApi .length !==this.state.rulesListApi.length ){
            this.setState({ rulesList: this.getIpv4Oripv6(prevProps.rulesListApi),
                rulesListApi:prevProps.rulesListApi,isAction:true});
        }
    }



    getIpv4Oripv6(inpData) {
        this.props.bgShadowHandler(true)
        let locData = [];
        if (inpData.length === 0) {
            return locData;
        }
        locData = this.setRowData(inpData);
        
        return this.getUniqueSource(locData);
    }

    getUniqueSource(data) {
        let uiqueData = []
        data.forEach(element => {
            let ob = uiqueData.find(item=>item.type===element.type && item.direction===element.direction 
                    && item.remote_ip_prefix===element.remote_ip_prefix && item.ethertype===element.ethertype 
                    && item.protocol === element.protocol)
            if(ob===undefined)   uiqueData.push(element)     
        });
        return uiqueData
    }
    
    setRowData(inpData) {
        let locData = [];
        for (let elem of inpData) {
            let newData ={};
            let sourceValue = getSourceValue(elem.remote_ip_prefix,elem.ethertype);
            if (elem.port_range_min === null && elem.protocol === null) {
                //elem.port_range_min=elem.port_range_max='';
                elem.protocol='any';
                if( elem.remote_ip_prefix===null){
                    elem.remote_ip_prefix = elem.ethertype ==='IPv6'?'::/0':'0.0.0.0/0'

                }
            }
            if(elem.protocol == 'ipv6-icmp'){
                elem.protocol = 'icmp'
            }
            //newData = locData.find(e => e.minPort == elem.port_range_min && e.maxPort == elem.port_range_max && e.protocol == elem.protocol);
            //if (newData === undefined) {
               // newData = {};
                newData.staticSources = [];
                newData.protocol = elem.protocol;
                newData.maxPort = elem.port_range_max;
                newData.minPort = elem.port_range_min;
                let firewallOption = this.state.firewallOptions.find
                    (ob => ob.protocol == elem.protocol && ob.minPort == elem.port_range_min && ob.maxPort == elem.port_range_max);
                if (firewallOption===undefined){
                    newData.type = 'Custom';
                    if(elem.port_range_max!==elem.port_range_min){
                        newData.portRange = elem.port_range_min +':'+ elem.port_range_max;
                    }else{
                        newData.portRange = elem.port_range_min;
                    }
                } else {
                    newData.type = firewallOption.type;
                    newData.portRange = firewallOption.portRange;
                }
               // newData.sources = [];
                newData.ethertype = elem.ethertype
                newData.value = sourceValue
                newData.id = elem.id
                newData.direction = elem.direction
                newData.remote_ip_prefix = elem.remote_ip_prefix
                locData.push(newData);
            //} 
            // else if (newData !== undefined) {
            //     newData.sources.push({
            //         ethertype: elem.ethertype,
            //         value: sourceValue,
            //         direction: this.props.type,
            //         id: elem.id,
            //         remote_ip_prefix: elem.remote_ip_prefix
            //     });
            // }
        }
        return locData;
    }

    render() {
        let emptyMessage = '';
        if(this.state.type==='IPv4'){
            if( this.state.rulesList.length ===0){
                emptyMessage = 'No IPv4 firewall rules found'
            }else {
                emptyMessage = 'Loading ipv4 firewall rules...'
            }
        } 
        if(this.state.type==='IPv6'){
            if( this.state.rulesList.length ===0){
                emptyMessage = 'No IPv6 firewall rules found'
            }else {
                emptyMessage = 'Loading ipv6 firewall rules...'
            }
        }
        return (
            <React.Fragment>
                <div className="rules_table clearfix">
                    <div className="tabular_data_wrap">
                        <div className="table_header">
                            <ul>
                                <li className="th">
                                    <div className="col col1">Rule</div>
                                    <div className="col col2 colTraffic">Traffic</div>
                                    <div className="col col3">Protocol</div>
                                    <div className="col col4"><span>Port</span><span className="caption">(or range)</span>
                                        {/* <span className="question_icon" data-toggle="tooltip" data-tip data-for="portrange">
                                            <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="15px">?</text>
                                            </svg>
                                        </span><ReactToolTip id="portrange" place="top" effect="solid">You can specify a port number or <br/> a colon separated port range <br/> (TCP/UPD only)</ReactToolTip> */}
                                    </div>
                                    <div className="col col5">Sources</div>
                                   
                                </li>
                            </ul> 
                        </div>
                        <div className="table_data">
                            {this.state.rulesList.length ===0?
                                <ul>
                                    <li className="tr table_data_empty">
                                        <div className="outer_empty_wrap">
                                            <div className="inner_empty_wrap">
                                                <div className={this.state.type === "IPv4" ? "svg_wrap empty_icon inbound_empty" : "svg_wrap empty_icon inbound_empty"}></div>
                                                <p className="empty_title">{emptyMessage}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            :
                            <ul>
                                {this.state.rulesList.map((elem, i) =>
                                    <li className="tr" key={i}>
                                        <div className="col col1">
                                            {elem.type}
                                        </div>
                                        <div className="col col2 colTraffic">
                                            {elem.direction==='ingress'?'Inbound':'Outbound'}
                                        </div>
                                        <div className="col col3 ">
                                            {elem.protocol}
                                        </div>
                                        <div className="col col4 ">
                                            {elem.portRange!=""?elem.portRange:<span>&nbsp;</span>}

                                        </div>
                                        <div className="col col5">
                                                <ul className="tags_container">
                                                {this.props.type==='IPv4' && <div className="source_tag" >{elem.remote_ip_prefix==='0.0.0.0/0'?'All IPv4':'Custom'}</div>}
                                                {this.props.type==='IPv6' && <div className="source_tag" >{elem.remote_ip_prefix==='::/0'?'All IPv6':'Custom'}</div>}
                                                <span>{elem.remote_ip_prefix}</span>
                                                </ul>
                                        </div>
                                    </li>
                                )
                                }
                            </ul>
                            }
                        </div>
                    </div>
                </div>

            </React.Fragment>
        )
    }
}
function validateIpAddress(ipAddress) {
    var expression =  /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
    return expression.test(ipAddress);
}
function getEtherType(value) {
    if(value.includes(':')) {
        return 'IPv6';
    }
    return 'IPv4';
    
}
function getRemotePrefix(type){
    if(type==='IPv4'){
        return '0.0.0.0/0';
    }
    return '::/0';
}
function getSourceValue(ipPrefix,ethertype) {
    if (ipPrefix === '0.0.0.0/0') {
        return 'ALLIPv4';
    } else if (ipPrefix === '::/0') {
        return 'ALLIPv6';
    } else if (ipPrefix===null){
        return 'ALL'+ethertype;
    }else{
        return ipPrefix;
    }
}

export default NetworkRules;